import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WheelchairPickupIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wheelchair_pickup"}/>
}
